import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface Props {
  children: JSX.Element;
  text: string;
}

export const MouseOverPopover = ({ children, text }: Props): JSX.Element => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <Box
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </Box>

      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
          backgroundColor: "transparent",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box display={"flex"}>
          <Box
            width={"40px"}
            bgcolor={"var(--green)"}
            alignContent={"center"}
            textAlign={"center"}
            borderRadius={"4px 0 0 4px"}
          >
            <InfoIcon color="white" sx={{ height: "11px" }} />
          </Box>
          <Box
            bgcolor={"var(--white)"}
            p={"10px 16px 10px 16px"}
            borderRadius={"0 4px 4px 0"}
            maxWidth={"260px"}
          >
            <Typography sx={{ p: 1 }}>{text}</Typography>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};
